<div class="project-config-container" appUserManual [userManualKey]="'project-configuration'">
  @if (groupedConfig?.length) {
    @for (group of groupedConfig; track group.category) {
      <app-project-config-section [category]="group.category" [items]="group.items"></app-project-config-section>
    }
  }
</div>
